import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60fb1488"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  "data-keyboard": "true",
  tabindex: "-1",
  role: "dialog",
  id: "add-preferredclient-modal",
  "aria-labelledby": "`add-preferredclient-modal-label`",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-lg modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "add-preferredclient-modal-label"
  }, " Preferred client "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1))
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "form-group row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label offset-2" }, "Company", -1))
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label offset-2" }, "Branch", -1))
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = {
  key: 0,
  class: "error-message"
}
const _hoisted_13 = { class: "modal-footer" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary mr-auto",
  "data-dismiss": "modal"
}, " Back ", -1))
const _hoisted_15 = ["disabled"]

import { ref, computed, watch, onMounted, inject } from 'vue';
import { useStore } from 'vuex';
import { Customer } from '@/models';
import { useToast } from 'vue-toastification';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddPreferredClientModal',
  setup(__props) {

const store = useStore();
const actProperty: any = inject('actProperty');

const companyNameOptions = ref<string[]>([]);
const branchNameOptions = ref<string[]>([]);
const selectedCompanyName = ref('');
const selectedBranchName = ref('');
const selectedCustomer = ref<Customer | undefined>();
const error_message = ref('');

const customerCompanyName = computed({
  get: () => selectedCompanyName.value,
  set: (name: string) => {
    selectedCompanyName.value = name;
  }
});

const customerBranchName = computed({
  get: () => selectedBranchName.value,
  set: (name: string) => {
    selectedBranchName.value = name;
  }
});

const errorMessage = computed({
  get: () => error_message.value,
  set: (val: string) => {
    error_message.value = val;
  }
});

const getCompanyNameOptions = async () => {
  companyNameOptions.value = await store.dispatch('customers/getCompanyNameOptions');
};

const getBranchNameOptions = async (companyName: string) => {
  branchNameOptions.value = await store.dispatch('customers/getBranchNameOptions', companyName);
};

const addPreferredClient = async (client: Customer) => {
  await store.dispatch('inspectors/addPreferredClient', client);
};

const getCustomers = async (payload: {
  starts_with?: string;
  company_name?: string;
  branch_name?: string;
}) => {
  return await store.dispatch('customers/getCustomers', payload) as Customer[];
};

const onSelectCompanyName = async (companyName: string) => {
  if (companyName) {
    selectedCompanyName.value = companyName;
    selectedBranchName.value = '';
    await getBranchNameOptions(companyName);
  }
};

const onTagCompanyName = async (val: string) => {
  selectedCompanyName.value = val;
  if (!selectedCompanyName.value) {
    selectedBranchName.value = '';
  }
  error_message.value = '';
};

const onSelectBranchName = async (branchName: string) => {
  if (branchName) {
    const customers: Customer[] = await getCustomers({
      company_name: customerCompanyName.value,
      branch_name: branchName,
    });

    if (customers.length) {
      selectedBranchName.value = branchName;
    }

    if (customers && customers.length === 1) {
      selectedCustomer.value = customers[0];
      error_message.value = '';
    } else if (customers && customers.length > 1) {
      selectedCustomer.value = undefined;
      error_message.value = `${customerCompanyName.value} has ${customers.length} branches with name ${selectedBranchName.value}`;
    }
  }
};

const onTagBranchName = async (val: string) => {
  selectedBranchName.value = val;
  error_message.value = '';
};

const canAdd = computed(() => {
  return customerCompanyName.value && selectedBranchName.value && !errorMessage.value;
});

const add = async () => {
  if (selectedCustomer.value) {
    await addPreferredClient(selectedCustomer.value);
  }
};

onMounted(async () => {
  try {
    await getCompanyNameOptions();
  } catch (err: any) {
    actProperty.displayError(err);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_multiselect_text = _resolveComponent("multiselect-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", null, [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_multiselect_text, {
                    modelValue: customerCompanyName.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customerCompanyName).value = $event)),
                    value: customerCompanyName.value,
                    options: companyNameOptions.value,
                    "allow-empty": true,
                    taggable: true,
                    onTag: onTagCompanyName,
                    onSelect: onSelectCompanyName
                  }, _createSlots({ _: 2 }, [
                    (customerCompanyName.value.length)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onTagCompanyName('')), ["prevent","stop"])),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear Company Name"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "value", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_multiselect_text, {
                    modelValue: customerBranchName.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((customerBranchName).value = $event)),
                    value: customerBranchName.value,
                    options: branchNameOptions.value,
                    "allow-empty": true,
                    disabled: customerCompanyName.value.length < 1,
                    taggable: true,
                    onTag: onTagBranchName,
                    onSelect: onSelectBranchName
                  }, _createSlots({ _: 2 }, [
                    (customerBranchName.value.length)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (onTagBranchName('')), ["prevent","stop"])),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear Branch Name"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "value", "options", "disabled"]),
                  (errorMessage.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(errorMessage.value), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary",
            "data-dismiss": "modal",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (add()), ["prevent"])),
            disabled: !canAdd.value
          }, " Add ", 8, _hoisted_15)
        ])
      ])
    ])
  ]))
}
}

})